export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13810.beee0cb8.jpg";